import { Paper, Typography } from '@mui/material';
import { Link } from 'react-router-dom';
import { SIGNIN } from '../../core/router/routes';

const PROHIBITED = [
  'Copiar, reproducir, redistribuir o compartir con terceros el acceso o el contenido.',
  'Realizar ingeniería inversa, descompilar o intentar obtener el código, la lógica o el diseño de las herramientas, incluso mediante agentes o programas de inteligencia artificial.',
  'Extraer datos de forma automatizada (scraping, bots o similares).',
  'Crear productos derivados o competidores a partir de ellos.',
];

const Terms = () => {
  return (
    <div className="flex flex-col flex-1 items-center p-16 sm:p-48" style={{ backgroundColor: '#f8fafc' }}>
      <Paper className="w-full max-w-3xl p-24 sm:p-48" sx={{ borderRadius: 4 }}>
        <img
          className="h-48"
          src={`${process.env.PUBLIC_URL}/assets/images/logo/vlogo.png`}
          alt="logo"
        />

        <Typography variant="h4" className="mt-32 font-extrabold tracking-tight" sx={{ color: '#0f172a' }}>
          Términos de uso
        </Typography>
        <Typography variant="body2" color="text.secondary" className="mt-4">
          Última actualización: 23 de octubre de 2026
        </Typography>

        <Typography className="mt-24">
          Al ingresar a la Academia Inversapiens o a cualquiera de sus plataformas y herramientas
          aceptas estos términos.
        </Typography>

        <Typography variant="h6" className="mt-32 font-bold" sx={{ color: '#0f172a' }}>
          Propiedad intelectual y uso de las herramientas
        </Typography>
        <Typography className="mt-8">
          Las herramientas, plataformas, carteras, reportes, análisis, clases y demás contenidos de
          Inversapiens y El Club de Trading son de su propiedad exclusiva y están protegidos por la
          Ley N° 17.336 de Propiedad Intelectual. El acceso se otorga solo para uso personal del
          alumno mientras su suscripción o compra esté vigente.
        </Typography>

        <Typography className="mt-16">Queda prohibido:</Typography>
        <ul className="mt-8 list-disc" style={{ paddingLeft: 24 }}>
          {PROHIBITED.map((item) => (
            <li key={item} className="mt-4">
              <Typography>{item}</Typography>
            </li>
          ))}
        </ul>

        <Typography className="mt-16">
          El incumplimiento faculta a Inversapiens para cancelar el acceso sin reembolso y ejercer las
          acciones legales que correspondan.
        </Typography>

        <Typography className="mt-16">
          Inversapiens puede actualizar estos términos. La versión vigente es la publicada en esta
          página.
        </Typography>

        <Link className="block font-medium mt-32" to={SIGNIN}>
          Volver a la Academia
        </Link>
      </Paper>
    </div>
  );
};

export default Terms;
